// extracted by mini-css-extract-plugin
module.exports = {"areaChart":"style__areaChart___2XHPX"};